import { RootState } from 'shared/config/redux/store'

export const getUserData = (s: RootState) => s.auth.user
